export const BRAND_NAME = "1Rupee Clinic";
export const BRAND_SHORT = "1Rupee";
export const MEMBERSHIP_NAME = "1Rupee Clinic Annual Membership";

export const CONTACT_PHONE = "+91 81044 83706";
export const CONTACT_PHONE_HREF = "tel:+918104483706";
export const CONTACT_EMAIL = "account@1rupeeclinic.com";
export const CONTACT_EMAIL_HREF = "mailto:account@1rupeeclinic.com";
